<template>
    <div class="col profile-box-billing">
       
       <!--  <b-card class="mt-3" header="Form Data Result">
          <pre class="m-0">{{ form }}</pre>
        </b-card> -->

        <div class="col billing-info-item billing-info-first-box">
            <!-- <button class=" btn  btn-primary posi-right" @click="$bvModal.show('add-card')">Add your card</button>    -->
            <div class="col-sm-8 info-content" v-if="recentAddress!=''">
                <!-- <span class="edit"><b-icon icon="pencil" ></b-icon></span> -->
                <h3>Billing address</h3>
                
                <ul class="billingaddress">
                      <li class="address-name"><h3>{{recentAddress.first_name}} {{recentAddress.last_name}}</h3></li>
                            <li class="address-line2">{{recentAddress.address_line_1 +' '+recentAddress.address_line_2}}</li>
                            <li class="address-line2">{{recentAddress.city}}</li>
                            <li class="statepostal">{{recentAddress.state}} - {{recentAddress.pincode}}</li>
                            <li class="country">India</li>
                </ul>
                <p><a href="javascript://" class=" btn  btn-primary" @click="$bvModal.show('edit-address')">Edit</a> </p>
                
            </div>           
        </div>
        <div class="col billing-info-item">
                
            <div class="col-sm-12 info-content">
                <!-- <span class="edit"><b-icon icon="pencil" ></b-icon></span> -->
                <h3>Other addresses</h3>
                <div class="row"> 
                    <div class="col-4 col-xs-12 address-item" v-for="list in billingAddress" :key="list.id">
                        <ul class="billingaddress">
                            <li class="address-name"><h3>{{list.first_name}} {{list.last_name}}</h3></li>
                            <li class="address-line2">{{list.address_line_1 +' '+list.address_line_2}}</li>
                            <li class="address-line2">{{list.city}}</li>
                            <li class="statepostal">{{list.state}} - {{list.pincode}}</li>
                            <li class="country">India</li>
                        </ul>
                        <p><a href="javascript://" class=" btn  btn-primary" @click="ShowModal('edit-address',list)">Edit</a> </p> 
                    </div> 
                    
                </div>
                
                
            </div>           
        </div>
        <div class="col billing-info-item">
            <div class="col-sm-8 info-content">
                <h3>Card Details</h3>
                <!-- <form class="frm-add-card">
                    <div class="form-group">
                        <label for="name">Name on card</label>
                        <input type="text" class="form-control" id="name" placeholder="Name on card">
                    </div>
                    <div class="form-group">
                        <label for="card-no">Card number</label>
                        <input type="text" class="form-control" id="card-no" placeholder="Card number">
                    </div> 
                    <div class="form-group row">
                        <div class="col">
                            <label for="expiry">Expiry date</label>
                            <div class="row">  
                                
                                <div class="col">
                                   <select id="dob" class="form-control">
                                        <option value="0">Month</option>
                                        <option v-for="month in 12" :key="month" :value="month"><span v-if="month<10">0</span>{{ month }}</option>
                                    </select>
                                </div>
                                <div class="col">
                                   <select id="dob" class="form-control">
                                        <option value="0">Year</option>
                                        <option v-for="year in years" :key="year" :value="year">{{ year }}</option>
                                    </select>
                                </div> 
                            </div>
                            
                        </div>
                        <div class="col">
                            <label for="ccv">CCV</label>
                            <input type="text" class="form-control" id="ccv" placeholder="CCV">   
                        </div>
                    </div>
                    <button class=" btn  btn-primary">Add your card</button>
                </form> -->
            </div>           
        </div>
        <b-modal id="edit-address" size="lg" centered title="Edit billing address" class="address-modal"  hide-footer>
            <div class="edit-address">
	    <form method="post" action="" class="billing-form" id="initial">
            <input type="hidden" name="id" v-model="editData.id"/>
			<div class="col-xs-12 col-sm-6 col-md-6 p-l-r-0 f-left">
			  	<div class="form-group">
			    	<input type="text" name="first_name" id="first_name" v-model="editData.first_name"  class="form-control input-sm" placeholder="First Name" value="">
                    <span class="text-danger"  id="first_name_e">{{toStr(editErrors.first_name)}}</span>
			  	</div>
			</div>
			<div class="col-xs-12 col-sm-6 col-md-6 right-sec  f-left">
			  	<div class="form-group">
			    	<input type="text" name="last_name" id="last_name" v-model="editData.last_name" class="form-control input-sm" placeholder="Last Name" value="">
                    <span class="text-danger"  id="last_name_e">{{toStr(editErrors.last_name)}}</span>
			  	</div>
			</div>
			<div class="col-xs-12 col-sm-6 col-md-6 p-l-r-0 f-left ">
			  	
			      		<div class="form-group">
			        		<input type="text" name="email" id="email" v-model="editData.email" class="form-control input-sm" placeholder="Email ID" value="">
                            <span class="text-danger"  id="email_e">{{toStr(editErrors.email)}}</span>
			      		</div>
			    	
			</div>
			<div class="col-xs-12 col-sm-6 col-md-6 right-sec f-left">
			  
					     <div class="form-group">
					        <input type="text" name="mobile_no" id="mobile_no" v-model="editData.contact" class="form-control input-sm" placeholder="Mobile Number" value="">
                             <span class="text-danger"  id="contact_e">{{toStr(editErrors.contact)}}</span>
					     </div>
				    
			</div>
			<div class="col-xs-12 col-sm-6 col-md-6 p-l-r-0 f-left">
			  	<div class="form-group">
			   		<input type="text" name="address_line1" id="address_line1" v-model="editData.address_line_1" class="form-control input-sm" placeholder="house number/ building ">
                        <span class="text-danger"  id="address_line_1_e">{{toStr(editErrors.address_line_1)}}</span>
			  	</div>
			</div>
			<div class="col-xs-12 col-sm-6 col-md-6 right-sec f-left">
			  	<div class="form-group">
			    	<input type="text" name="address_line2" id="address_line2" v-model="editData.address_line_2" class="form-control input-sm" placeholder="street details">
                    <span class="text-danger"  id="address_line_2_e">{{toStr(editErrors.address_line_2)}}</span>
			  	</div>
			</div>
			<div class="col-xs-12 col-sm-6 col-md-6 p-l-r-0 f-left">
			  	<div class="form-group">
			    	<input type="text" name="city" id="city" v-model="editData.city" class="form-control input-sm" placeholder="city">
                     <span class="text-danger"  id="city_e">{{toStr(editErrors.city)}}</span>
			  	</div>
			</div>
			<div class="col-xs-12 col-sm-6 col-md-6 right-sec f-left">
			  	<div class="form-group">
			    	<input type="text" name="state" id="state" v-model="editData.state" class="form-control input-sm" placeholder="State">
                    <span class="text-danger"  id="state_e">{{toStr(editErrors.state)}}</span>
			  	</div>
			</div>
			<div class="col-xs-12 col-sm-6 col-md-6 p-l-r-0 f-left">
			  	<div class="form-group">
			    	<input type="text" name="country" id="Country"  class="form-control input-sm" placeholder="Country" value="India" readonly>
			  	</div>
			</div>
			<div class="col-xs-12 col-sm-6 col-md-6 right-sec f-left">
			  	<div class="form-group">
			    	<input type="text" name="pincode" id="pincode" v-model="editData.pincode" class="form-control input-sm" placeholder="Pincode">
                    <span class="text-danger"  id="pincode_e">{{toStr(editErrors.pincode)}}</span>
			  	</div>
			</div>
			<div class="col-xs-12 col-sm-12 col-md-12 p-l-r-0 f-left">
			    	<a href="javascript://" class=" btn  btn-primary" @click="SaveUpdate()">Save</a>
			</div>
		</form>
	</div>
        </b-modal>
        <b-modal id="add-card" size="lg" centered title="Add Card" class="address-modal"  hide-footer>
             <form class="frm-add-card">
                    <div class="form-group">
                        <label for="name">Name on card</label>
                        <input type="text" class="form-control" id="name" placeholder="Name on card">
                    </div>
                    <div class="form-group">
                        <label for="card-no">Card number</label>
                        <input type="text" class="form-control" id="card-no" placeholder="Card number">
                    </div> 
                    <div class="form-group row">
                        <div class="col">
                            <label for="expiry">Expiry date</label>
                            <div class="row">  
                                
                                <div class="col">
                                   <select id="dob" class="form-control">
                                        <option value="0">Month</option>
                                        <option v-for="month in 12" :key="month" :value="month"><span v-if="month<10">0</span>{{ month }}</option>
                                    </select>
                                </div>
                                <div class="col">
                                   <select id="dob" class="form-control">
                                        <option value="0">Year</option>
                                        <option v-for="year in years" :key="year" :value="year">{{ year }}</option>
                                    </select>
                                </div> 
                            </div>
                            
                            <!-- <input type="text" class="form-control" id="expiry" placeholder="Expiry date"> -->   
                        </div>
                        <div class="col">
                            <label for="ccv">CCV</label>
                            <input type="text" class="form-control" id="ccv" placeholder="CCV">   
                        </div>
                    </div>
                    <button class=" btn  btn-primary">Add your card</button>
                </form>
        </b-modal>
    </div>
</template>
<script>
import profile from '../services/profile'
// import editAddress from './edit_address'
export default {
    name: 'billing_information',
    data() {
        return {
            billingAddress:{},
            editErrors:{
                first_name:[],
                last_name:[],
                email:[],
                contact:[],
                address_line_1:[],
                address_line_2:[],
                city:[],
                state:[],
                pincode:[],
            },
            editData:'',
            recentAddress:'',
            current_month:new Date().getMonth()+1
           }
            
    },
    
    props: [],
    components: {
        // editAddress
    },
    computed : {
        
    years () {
      const year = new Date().getFullYear()
      return Array.from({length: 10 }, (value, index) => year + index)
    }
  },
    watch: {
        
    },
    methods: {
        ShowModal(from,list){
            this.editData=list
            this.$bvModal.show(from)
        },
        SaveUpdate(){
            // $('first_name_e').htm3l('sdgdg');
            profile.UpdateBilling(this.editData)
                    .then((response) =>{
                        if(response.data.status=='success')
                        {
                             this.$bvModal.hide('edit-address');
                             this.$notify({ group: 'auth', text: 'Successfully updated.', type: 'success' })
                        }
                    })
                    .catch((error) =>{
                        var err=error.response.data.errors;
                        this.editErrors=err;
                    })
        },
        toStr(str){
            if(str!=undefined && ( str!=[] || str!='' || str.length>0)){
                return str.join();
            }
            return str;
        }
       
    },
    created(){
       
    },
    mounted(){
        profile.getBilling()
                .then(response=>{
                    // console.log(response.data);
                    this.billingAddress=response.data.profile
                    this.recentAddress=response.data.recentaddress
                });
               
    }
};
</script>
